"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutexEquality = exports.mutexBitwiseAnd = void 0;
function mutexBitwiseAnd(mutexA, mutexB) {
    return (mutexA & mutexB) !== 0;
}
exports.mutexBitwiseAnd = mutexBitwiseAnd;
function mutexEquality(mutexA, mutexB) {
    return mutexA === mutexB;
}
exports.mutexEquality = mutexEquality;
